<template>
  <div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Rua Transversal (A)"
        name="rua_transversal_a"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        name="rua_transversal_a"
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.rua_transversal_a"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Rua Transversal (B)"
        name="rua_transversal_b"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        v-model="itemOsContract.rua_transversal_b"
        name="rua_transversal_b"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Tap anterior e quantidade de conectados"
        name="tap_anterior_qtd_conectados"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        name="tap_anterior_qtd_conectados"
        v-model="itemOsContract.tap_anterior_qtd_conectados"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Tap posterior e quantidade de conectados"
        name="tap_posterior_qtd_conectados"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        name="tap_posterior_qtd_conectados"
        v-model="itemOsContract.tap_posterior_qtd_conectados"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 column q-mt-sm">
      <RequiredLabel
        title="Tap do cliente é conjugado?"
        name="isConjugadoValores"
      />
      <div class="flex row justify-around">
        <q-radio
          keep-color
          v-model="isConjugadoValores"
          size="lg"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          keep-color
          v-model="isConjugadoValores"
          size="lg"
          :val="0"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <div
      class="group-input col-12 row q-mt-sm"
      v-if="isConjugadoValores === 1"
    >
      <RequiredLabel
        title="Quais os valores?"
        name="tap_conjugado_valores"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.tap_conjugado_valores"
        name="tap_conjugado_valores"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="
          isConjugadoValores === 1 && [(val) => !!val || 'Campo Obrigatório']
        "
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Tap do cliente e suas respectivas quantidades de saídas"
        name="tap_quantidade_saidas"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.tap_quantidade_saidas"
        name="tap_quantidade_saidas"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Número dos imóveis conectados ao TAP"
        name="imoveis_conectados_ao_tap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.imoveis_conectados_ao_tap"
        name="imoveis_conectados_ao_tap"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import { inject, onBeforeMount, ref } from "vue";

  export default {
    name: "ServiceInfoForm",
    components: {
      RequiredLabel,
    },
    props: {
      itemOsContract: Object,
    },

    setup(props, { emit }) {
      const isConjugadoValores = ref(0);

      let formFields = {
        rua_transversal_a: "",
        rua_transversal_b: "",
        tap_anterior_qtd_conectados: "",
        tap_posterior_qtd_conectados: "",
        tap_conjugado_valores: "",
        tap_quantidade_saidas: "",
        imoveis_conectados_ao_tap: "",
      };
      const addFieldsToRequestData = inject("addFieldsToRequestData");

      onBeforeMount(() => {
        addFieldsToRequestData(formFields);
      });

      return {
        isConjugadoValores,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }
  .group-input {
    label {
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  }
</style>
